module.exports = __webpack_public_path__ + "static/booking-banner-nz-99c30f74eba61a24e973627f7d0a84ed.webp";